import { render, staticRenderFns } from "./standert-icons-group.vue?vue&type=template&id=fb8ce8a4&"
import script from "./standert-icons-group.vue?vue&type=script&lang=ts&"
export * from "./standert-icons-group.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports